import React from 'react';

export const GamePageSettingsContext = React.createContext({
    exitGame: {
        exitGameHandler: () => {},
        exitGameCtaText: '',
    },
    menuItems: [],
});
